import React from "react";
import "../styles/MacroRegimePanel.css";    
import "../styles/theme-cpg.css";   
import EconomicCalendar from "./EconomicCalendar";


export default function MarketEventsPage() {
  return (
    <div className="coach-page-wrap">
      <div className="coach-page-header">
      </div>

      <div className="coach-page-content-grid">
        <div className="coach-page-main-card">
          <EconomicCalendar />
        </div>
      </div>
    </div>
  );
}
